module.exports = __webpack_public_path__ + "static/1-f756bd46024991b179a21e316901eaf8.jpg";